<template>
  <div>
    <div class="mb-3">
      <table class="control-table">
        <tr v-if="perfil_AM">
          <td class="description-cell">
            Registrar como "REVISADA" en Auditoría Médica las atenciones de consulta que tiene un solo código en el detalle
          </td>
          <td class="input-cell"></td>
          <td class="button-cell">
            <button
              class="btn btn-outline-dark glow-naranja w-100"
              @click="ejecutarControl(1)"
              :disabled="loading"
            >
              <span v-if="loading && controlActivo === 1" class="spinner-border spinner-border-sm me-2"></span>
              Registrar como "REVISADA"
            </button>
          </td>
        </tr>
        <tr v-if="perfil_todos && p_inicial === 1">
          <td class="description-cell">
            Aplicar tarifarios (Convenio TPSNS, Medicamentos)
          </td>
          <td class="input-cell"></td>
          <td class="button-cell">
            <button
              class="btn btn-outline-dark glow-naranja w-100"
              @click="ejecutarControl(2)"
              :disabled="loading"
            >
              <span v-if="loading && controlActivo === 2" class="spinner-border spinner-border-sm me-2"></span>
              Aplicar tarifarios
            </button>
          </td>
        </tr>
        <tr v-if="perfil_AM">
          <td class="description-cell">
            Borrar en <b>BLOQUE</b> código del detalle de planillas
          </td>
          <td class="input-cell">
            <input
              v-model="codigo"
              type="text"
              class="form-control input-fixed-width"
              placeholder="Ingrese el código"
              id="codigo-borrar"
              name="codigo-borrar"
              :disabled="loading"
            />
          </td>
          <td class="button-cell">
            <button
              class="btn btn-outline-dark glow-naranja w-100"
              @click="ejecutarControl(3)"
              :disabled="loading"
            >
              <span v-if="loading && controlActivo === 3" class="spinner-border spinner-border-sm me-2"></span>
              Borrar código
            </button>
          </td>
        </tr>
        <tr v-if="perfil_AM">
          <td class="description-cell">
            Cambiar en <b>BLOQUE</b> código del detalle de planillas
          </td>
          <td class="input-cell">
            <input
              v-model="codigo_actual"
              type="text"
              class="form-control input-fixed-width"
              placeholder="Código actual"
              id="codigo-actual"
              name="codigo-actual"
              :disabled="loading"
            />
            <input
              v-model="codigo_nuevo"
              type="text"
              class="form-control input-fixed-width"
              placeholder="Código nuevo"
              id="codigo-nuevo"
              name="codigo-nuevo"
              :disabled="loading"
            />
          </td>
          <td class="button-cell">
            <button
              class="btn btn-outline-dark glow-naranja w-100"
              @click="ejecutarControl(4)"
              :disabled="loading"
            >
              <span v-if="loading && controlActivo === 4" class="spinner-border spinner-border-sm me-2"></span>
              Cambiar código
            </button>
          </td>
        </tr>
<tr v-if="perfil_AM">
  <td class="description-cell" rowspan="2">
    Mover planilla desde trámite <b>origen</b> a trámite <b>destino</b>
  </td>
  <td class="input-cell">
    <input
      v-model="tramite_origen"
      type="number"
      class="form-control input-fixed-width"
      placeholder="Trámite origen"
      id="tramite-origen"
      name="tramite-origen"
      disabled
    />
    <input
      v-model="planilla_origen"
      type="text"
      class="form-control input-fixed-width"
      placeholder="Planilla origen"
      id="planilla-origen"
      name="planilla-origen"
      :disabled="loading"
    />
  </td>
  <td class="button-cell">
    <button
      class="btn btn-outline-dark glow-naranja w-100 mb-2"
      @click="ejecutarControl(5)"
      :disabled="loading"
    >
      <span v-if="loading && controlActivo === 5" class="spinner-border spinner-border-sm me-2"></span>
      Mover planilla
    </button>
  </td>
</tr>
<tr v-if="perfil_AM">
  <td class="input-cell">
    <input
      v-model="tramite_destino"
      type="number"
      class="form-control input-fixed-width"
      placeholder="Trámite destino"
      id="tramite-destino"
      name="tramite-destino"
      :disabled="loading"
    />
    <input
      v-model="planilla_destino"
      type="text"
      class="form-control input-fixed-width"
      placeholder="Planilla destino"
      id="planilla-destino"
      name="planilla-destino"
      :disabled="loading"
    />
  </td>
  <td class="button-cell">
    <button
      class="btn btn-outline-dark glow-naranja w-100"
      @click="ejecutarControl(6)"
      :disabled="loading"
    >
      <span v-if="loading && controlActivo === 6" class="spinner-border spinner-border-sm me-2"></span>
      Planilla siguiente
    </button>
  </td>
</tr>
        <tr v-if="perfil_todos">
          <td class="description-cell">
            Registrar atenciones justificadas 
          </td>
          <td class="input-cell"></td>
          <td class="button-cell">
            <button
              class="btn btn-outline-dark glow-naranja w-100"
              @click="ejecutarControl(7)"
              :disabled="loading"
            >
              <span v-if="loading && controlActivo === 1" class="spinner-border spinner-border-sm me-2"></span>
              Registrar justificadas
            </button>
          </td>
        </tr>
      </table>
    </div>
    <div>
      <FuncionalidadesTramite
        :idTramite="Number(p_idTramite)"
        :idPrestador="Number(p_idPrestador)"
        :idUsuario="p_idUsuario ? Number(p_idUsuario) : null"
        @cargado="recargar"
      />
    </div>	
  </div>
</template>

<script>
import FuncionalidadesTramite from "@/components/FuncionalidadesTramite.vue";
import api from '@/services/api';
import Swal from 'sweetalert2';

export default {
  name: 'Controles',
  props: {
    p_idTramite:   { type: Number,  required: true },
    p_idPrestador: { type: Number,  required: true },
    p_inicial:     { type: Number,  required: true },
  },
  components: {
    FuncionalidadesTramite,
  },  
  data() {
    return {
      p_idPerfil: null,
      p_idUsuario: null,
      codigo: '',
      codigo_actual: '',
      codigo_nuevo: '',
      tramite_origen: '',
      tramite_destino: '',
      planilla_origen: '',
      planilla_destino: '',
      loading: false,
      controlActivo: null
    };
  },
  computed: {
    perfil_AM() {
      return (this.p_idPerfil == 17);
    },
    perfil_GD() {
      return (this.p_idPerfil == 19);
    },
    perfil_todos() {
      return (this.p_idPerfil == 17 || this.p_idPerfil == 19);
    },
  },
  mounted() {
    this.p_idPerfil  = window.sessionStorage.getItem("idPerfil");
    this.p_idUsuario = Number(window.sessionStorage.getItem("idUsuario")) || null;
    this.tramite_origen = this.p_idTramite;
  },
  methods: {
    recargar() {
    },
    async ejecutarControl(index) {
      // Validar que p_idTramite sea un número válido
      if (!Number.isInteger(this.p_idTramite) || this.p_idTramite <= 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'El ID del trámite no es válido.',
        });
        return;
      }

      // Validación de parámetros requeridos
      if (index === 3 && !this.codigo) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Por favor, ingrese el código a borrar.',
        });
        return;
      }

      if (index === 4 && (!this.codigo_actual || !this.codigo_nuevo)) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Por favor, ingrese tanto el código actual como el código nuevo.',
        });
        return;
      }

      if (index === 5) {
        if (!this.planilla_origen || !this.tramite_destino || !this.planilla_destino) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Por favor, complete todos los campos requeridos (planilla origen, trámite destino y planilla destino).',
          });
          return;
        }

        // Confirmación antes de mover la planilla
        const confirmacion = await Swal.fire({
          title: '¿Está seguro?',
          html: `Se moverá la planilla <b>${this.planilla_origen}</b> del trámite <b>${this.tramite_origen}</b> al trámite <b>${this.tramite_destino}</b> con el número <b>${this.planilla_destino}</b>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, mover',
          cancelButtonText: 'Cancelar'
        });

        if (!confirmacion.isConfirmed) {
          return;
        }
      }

      if (index === 6 && !this.tramite_destino) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Por favor, ingrese el trámite destino.',
        });
        return;
      }

      let endpoint = '';
      let params = {};

      // Selecciona el endpoint y parámetros según el índice
      switch (index) {
        case 1:
          endpoint = `/procedimientos/revisar-planillas-visita`;
          params = {
            idTramite: this.p_idTramite,
            idUsuario: this.p_idUsuario
          };
          break;
        case 2:
          endpoint = `/procedimientos/aplicar-tarifario-tramite`;
          params = { idTramite: this.p_idTramite };
          break;
        case 3:
          endpoint = `/procedimientos/borrar-elemento-planilladet`;
          params = {
            idTramite: this.p_idTramite,
            codigo: this.codigo,
            idUsuario: this.p_idUsuario
          };
          break;
        case 4:
          endpoint = `/procedimientos/cambiar-elemento-planilladet`;
          params = { 
            idTramite: this.p_idTramite, 
            codigo_actual: this.codigo_actual,
            codigo_nuevo: this.codigo_nuevo,
            idUsuario: this.p_idUsuario
          };
          break;
        case 5:
          endpoint = `/procedimientos/cambiar-tramite-planilla`;
          params = {
            idPlanilla: this.planilla_origen,
            idTramiteOrigen: this.tramite_origen,
            idTramiteDestino: this.tramite_destino,
            numeroOrigen: this.planilla_origen,
            numeroDestino: this.planilla_destino,
            idUsuario: this.p_idUsuario
          };
          break;
        case 6:
          endpoint = `/procedimientos/planilla-siguiente`;
          params = {
            idTramite: this.tramite_destino
          };
          break;
        case 7:
          endpoint = `/procedimientos/resolver-objecion-tramite`;
          params = {
            idTramite: this.p_idTramite,
            idUsuario: this.p_idUsuario
          };
          break;
        default:
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Acción no reconocida.',
          });
          return;
      }

      this.loading = true;
      this.controlActivo = index;

      try {
        const { data } = await api.post(endpoint, {}, { params });
//        console.log("Respuesta del backend:", data);

        // Mostrar alerta de éxito
        if(index < 6){
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: index === 1 ? 'Atenciones registradas como REVISADA.' :
                index === 2 ? 'Tarifarios aplicados correctamente.' :
                index === 3 ? 'Código borrado correctamente.' :
                index === 4 ? 'Código cambiado correctamente.' :
                'Planilla movida correctamente.',
          timer: 2000,
          showConfirmButton: false
        });
        }

        // Reiniciar los campos de entrada tras operaciones exitosas
        if (index === 3) this.codigo = '';
        if (index === 4) {
          this.codigo_actual = '';
          this.codigo_nuevo = '';
        }
        if (index === 5) {
          this.tramite_destino = '';
          this.planilla_origen = '';
          this.planilla_destino = '';
        }
        if (index === 6) {
          this.planilla_destino = data;
        }

        // Emitir evento para que el componente padre actualice los datos
        this.$emit('control-ejecutado', index);

      } catch (error) {
        console.error("Error al ejecutar control:", error);
        // Mostrar alerta de error con mensaje detallado
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.response?.data || 'Ocurrió un error al procesar la solicitud. Por favor, verifica los datos e intenta de nuevo.',
        });
      } finally {
        this.loading = false;
        this.controlActivo = null;
      }
    }
  }
};
</script>

<style src="@/assets/css/tabs.css" scoped></style>

<style scoped>
.btn {
  font-size: 16px;
  padding: 10px 20px;
}

.glow-naranja:hover:not(:disabled) {
  box-shadow: 0 0 12px rgba(255, 165, 0, 0.9), 0 0 20px rgba(255, 165, 0, 0.7);
}

.glow-negro:hover:not(:disabled) {
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.9), 0 0 20px rgba(0, 0, 0, 0.7);
}

.control-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.control-table tr {
  border-bottom: 1px solid #d3d3d3;
}

.control-table td {
  padding: 10px;
  vertical-align: middle;
}

.description-cell {
  width: 50%;
}

.input-cell {
  width: 25%;
  display: flex;
  gap: 10px;
}

.button-cell {
  width: 25%;
}

.input-fixed-width {
  width: 150px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
}
</style>